<template>
  <template v-if="setting.type == 'text'">
    <SettingTextInput :setting="setting" @change="onChange" type="text" :force-ltr="forceLtr"></SettingTextInput>
  </template>
  <template v-if="setting.type == 'textarea'">
    <SettingTextInput :setting="setting" @change="onChange" type="textarea"></SettingTextInput>
  </template>
  <template v-else-if="setting.type == 'number'">
    <SettingNumberInput :setting="setting" @change="onChange"></SettingNumberInput>
  </template>
  <template v-else-if="setting.type == 'bool'">
    <SettingBoolInput :setting="setting" @change="onChange"></SettingBoolInput>
  </template>
  <template v-else-if="setting.type == 'select'">
    <SettingSelectInput :setting="setting" @change="onChange"></SettingSelectInput>
  </template>
  <template v-else-if="setting.type == 'file'">
    <SettingFileInput :setting="setting" @change="onChange"></SettingFileInput>
  </template>
  <template v-else-if="setting.type == 'color'">
    <SettingColorInput :setting="setting" @change="onChange"></SettingColorInput>
  </template>
  <template v-else-if="setting.type == 'array'">
    <SettingArrayInput :setting="setting" @change="onChange"></SettingArrayInput>
  </template>
  <template v-else-if="setting.type == 'registers_custom_type'">
    <SettingRegistersInput :setting="setting"></SettingRegistersInput>
  </template>
</template>
<script setup lang="ts">

import SettingSelectInput from "@/components/settings/SettingSelectInput.vue";
import SettingTextInput from "@/components/settings/SettingTextInput.vue";
import SettingNumberInput from "@/components/settings/SettingNumberInput.vue";
import SettingBoolInput from "@/components/settings/SettingBoolInput.vue";
import SettingFileInput from "@/components/settings/SettingFileInput.vue";
import SettingColorInput from "@/components/settings/SettingColorInput.vue";
import SettingArrayInput from "@/components/settings/SettingArrayInput.vue";
import SettingRegistersInput from "@/components/settings/SettingRegistersInput.vue";

const props = defineProps(['setting', 'forceLtr'])

function onChange(e: any) {
  // push update and update global value
}

</script>
<style scoped>

</style>
